import { apiSlice } from "../apiSlice";

const secondaryUrl = "getquestionget.webapi";
const questionsExtendedSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuestionById: builder.mutation({
      query: ({ question_id }) => ({
        url: `${secondaryUrl}/`,
        method: "POST",
        body: { question_id: question_id }, // Pass the body here for POST
      }),
    }),
    getQuestionByQuestionId: builder.query({
      query: ({ question_id, choices }) => ({
        url: "getquestiononly.webapi/",
        headers: {
          "Question-id": question_id,
          "Answer-Choices":
            choices && choices[question_id] != undefined
              ? "[" + choices[question_id] + "]"
              : "",
        },
      }),
      // @ts-expect-error. Typescript hates redux I guess?
      providesTags: (result, error, { question_id }) => [
        { type: "Question", id: question_id },
      ],
    }),
    getQuestionImageById: builder.query({
      query: ({ question_id }) => ({
        url: `getQuestionMedia.webapi/?question_id=${question_id}`,
        headers: {
          "Question-id": question_id,
        },
        responseHandler: (response) => response.blob(),
        params: {
          cacheBusting: question_id,
        },
      }),
    }),
    getFullQuestionById: builder.query({
      query: ({ question_id }) => ({
        url: "getquestionget.webapi/",
        headers: {
          "Question-id": question_id,
        },
      }),
    }),
    getModel: builder.query({
      query: ({ part }) => ({
        url: "3dimage.webapi/",
        headers: {
          Image: part,
        },
      }),
    }),
    viewPerscriptionAnswer: builder.mutation({
      query: ({ question_id, answer, prescriptions }) => ({
        url: "viewprescriptionanswer.webapi/",
        method: "POST",
        body: {
          question_id,
          answer,
          prescriptions: prescriptions || {},
        },
      })
    }),
    // Fetches the image for a single answer choice by its serial number.
    // Only call this when answer.answer_choice_image is non-null.
    getAnswerChoiceImage: builder.query({
      query: ({ answer_serial }) => ({
        url: "getanswerchoiceimage.webapi/",
        headers: {
          "answer-serial": String(answer_serial),
        },
        responseHandler: (response) => response.blob(),
        params: {
          cacheBusting: answer_serial,
        },
      }),
    }),
  }),
});

export const {
  useGetQuestionByIdMutation,
  useGetQuestionByQuestionIdQuery,
  useGetQuestionImageByIdQuery,
  useGetFullQuestionByIdQuery,
  useGetModelQuery,
  useViewPerscriptionAnswerMutation,
  useGetAnswerChoiceImageQuery,
} = questionsExtendedSlice;